import React from "react";
import { Logo } from "./UIComponents";

export default function LegalPageLayout({ title, lastUpdated, children }) {
  return (
    <div className="min-h-screen font-sans text-slate-800 bg-white overflow-x-hidden">
      <header className="sticky top-0 z-40 bg-white/80 backdrop-blur-md border-b border-slate-200">
        <div className="container mx-auto px-6 max-w-5xl py-4 flex items-center justify-between gap-4">
          <a href="#!/" className="block">
            <Logo size="lg" />
          </a>
          <a
            href="#!/"
            className="text-sm font-semibold text-blue-600 hover:text-blue-700 transition"
          >
            Back to Home
          </a>
        </div>
      </header>

      <main className="container mx-auto px-6 max-w-5xl py-12">
        <h1 className="text-4xl md:text-5xl font-extrabold text-slate-900 tracking-tight">
          {title}
        </h1>
        <p className="mt-3 text-sm font-semibold text-slate-500">
          Last Updated: {lastUpdated}
        </p>

        <div className="prose prose-slate max-w-none mt-10">
          {/* Tailwind CDN is present; "prose" works if typography plugin isn't available it simply won't apply. */}
          <div className="space-y-6 text-slate-700 leading-relaxed">{children}</div>
        </div>
      </main>

      <footer className="bg-slate-50 pt-10 pb-10 border-t border-slate-200">
        <div className="container mx-auto px-6 max-w-5xl text-sm font-medium text-slate-500 flex flex-col md:flex-row gap-2 md:items-center md:justify-between">
          <span>© 2026. All rights reserved.</span>
          <span className="flex gap-4">
            <a href="#!/privacy" className="hover:text-blue-600 transition">
              Privacy Policy
            </a>
            <a href="#!/terms" className="hover:text-blue-600 transition">
              Terms of Service
            </a>
            <a href="#!/data-deletion" className="hover:text-blue-600 transition">
              Data Deletion Policy
            </a>
          </span>
        </div>
      </footer>
    </div>
  );
}


